// extracted by mini-css-extract-plugin
export default {"referral-widget":"Ml","referral-page":"Nl","label":"Ol","subHed":"Pl","profile-container":"Ql","referral-container":"Rl","referral-header":"Sl","shareMethodRow":"Tl","shareMethod":"Ul","active":"Vl","referral-stat":"Wl","blockwrapper":"Xl","referralLink":"Yl","bold":"Zl","semibold":"am","shareAgainButton":"bm","policy":"cm","narrowWrapper":"em"};
    if(module.hot) {
      // 1713996740342
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  